import React from "react";
import UseCaseTemplate from "./UseCaseTemplate";
import sportHero from "./assets/sport/first.png";
import sportCycle from "./assets/sport/sport1.jpg";
import sportFootball from "./assets/sport/sport2.jpg";
import sportMarathon from "./assets/sport/sport3.jpg";
import sportAction from "./assets/sport/Chsecond.png";
import sportMatchday from "./assets/sport/7cb06da7-8e54-44dc-92c5-83e1fbd1b099.png";
import sportUltra from "./assets/sport/sport6.jpg";
import sportReview from "./assets/sport/sport7.png";
import sportDrop from "./assets/sport/sport8.jpg";
import sportVideo from "./assets/sport/sport.mp4";

const experiences = [
  {
    id: "mountain-pass-relay",
    number: "01",
    category: "Road cycling",
    title: "The Mountain Pass Relay & Legendary Stages",
    lead: "Across a 180 km mountain stage, hand the cinematic baton from kilometer marker to kilometer marker.",
    layout: "Relay",
    layoutDetail: "Spatial hand-off across the route",
    workflowTitle: "A living mountain stage",
    workflow: [
      "Slot 1: the base of the climb filmed by an accredited regional media outlet.",
      "Slot 2: the iconic supporters’ hairpin turn captured on mobile by a local spectator Weaver.",
      "Slot 3: the decisive attack under the flamme rouge filmed by a motorcycle cameraman.",
      "AI aligns colorimetry and harmonizes spatial transitions along the ascent.",
    ],
    outcome1Label: "Organizer impact",
    outcome1: "The organizer can commercialize stage sponsor packs integrated into slots without interrupting the primary stream.",
    outcome2Label: "Weaver monetization",
    outcome2: "Automated €30–€100 bounties in the supplied concept can release from Smart Escrow when a roadside spectator clip is verified and woven into the official route stream.",
    image: sportCycle,
  },
  {
    id: "terrace-roar",
    number: "02",
    category: "Football & stadium sports",
    title: "Terrace Roar & Interactive Matchday",
    lead: "Blend the club’s official tactical feed with raw fan reactions and terrace sound in one synchronized matchday object.",
    layout: "Seed + Symphony",
    layoutDetail: "Official feed, participatory fan slots and synchronized stadium audio",
    workflowTitle: "Collective matchday layer",
    workflow: [
      "Master track: pure terrace-chant audio captured by stadium ambient microphones.",
      "Participatory slots: 10-second fan reactions from accredited season ticket holders during key moments.",
      "AI Content Guard filters profanity and inappropriate gestures.",
      "Passive spectators can be face-blurred for privacy compliance.",
    ],
    outcome1Label: "Club impact",
    outcome1: "A club can sell a persistent Digital Matchday Pass (€2–€5 in the supplied concept) to remote or international supporters.",
    outcome2Label: "Weaver monetization",
    outcome2: "Supporters whose reactions are selected can receive Smart Escrow micro-royalties per view or engagement, alongside direct community tipping.",
    image: sportFootball,
    video: sportVideo,
  },
  {
    id: "finisher-stream",
    number: "03",
    category: "Marathons & mass races",
    title: "The “Finisher Living Stream”",
    lead: "Replace static finish-line photos with a modular personalized video timeline for each runner.",
    layout: "Storyboard",
    layoutDetail: "Personalized race timeline",
    workflowTitle: "Runner progression slots",
    workflow: [
      "Starting corral and morning pre-race energy.",
      "Halfway split captured by official pacers.",
      "Mile 20 / Kilometer 35 “The Wall” captured by family or trackside points.",
      "Finish-line crossing with medal in hand.",
    ],
    outcome1Label: "Runner & organizer impact",
    outcome1: "The supplied concept proposes a €15 interactive digital finisher pack, with organizers capturing an illustrative ~40% net margin and no physical production overhead.",
    outcome2Label: "Weaver monetization",
    outcome2: "Pacers and course videographers can earn a flat commission, for example €1 per tracked runner, released once the timeline verifies.",
    image: sportMarathon,
  },
  {
    id: "polyphonic-board",
    number: "04",
    category: "Action sports",
    title: "Polyphonic Board & Action Sports",
    lead: "Triangulate an extreme-sports line or wave ride across synchronized sound and multiple visual angles.",
    layout: "Symphony",
    layoutDetail: "Multi-angle audio-visual synchronization",
    workflowTitle: "Acoustic impact locked to the maneuver",
    workflow: [
      "Audio track: waterproof deck microphone capturing the lip snap or skate-deck pop.",
      "Video Slot 1: continuous low-altitude chase footage from an FPV drone pilot.",
      "Video Slot 2: telephoto angle from the beach or bottom of the terrain park.",
      "AI removes drone-distance audio lag and locks board impact to the visual maneuver.",
    ],
    outcome1Label: "Sponsor impact",
    outcome1: "Action-sports brands can deploy shoppable living-media campaigns that link featured apparel and gear directly to checkout.",
    outcome2Label: "Weaver monetization",
    outcome2: "The supplied split example routes 50% to the athlete, 30% to the FPV pilot and 20% to the audio engineer/editor.",
    image: sportAction,
  },
  {
    id: "dplus3-matchday",
    number: "05",
    category: "Football, rugby & team sports",
    title: "The D+3 Living Matchday Sheet",
    lead: "Let the same matchday asset develop for 72 hours on the exact URL already shared across club channels.",
    layout: "Storyboard + Symphony",
    layoutDetail: "Evolving chronological flow plus synchronized match audio",
    workflowTitle: "From H-1 to D+3",
    workflow: [
      "H-1: team-bus arrival and tactical lineup insight.",
      "Live: decisive goal and raw terrace chants populate new slots.",
      "H+2: hot-swap the pre-match slot with the captain’s immediate post-match reaction.",
      "D+1 to D+3: independent tactical analysts inject structured breakdowns.",
    ],
    outcome1Label: "Club impact",
    outcome1: "A Living Match Pass can compound in perceived value after the match instead of depreciating at the final whistle.",
    outcome2Label: "Weaver monetization",
    outcome2: "Club journalists, accredited fans and analysts can receive recurring Smart Escrow royalties as their slot updates generate downstream views.",
    image: sportMatchday,
  },
  {
    id: "ultra-endurance",
    number: "06",
    category: "UTMB, gravel & rally raids",
    title: "The Ultra-Endurance Living Thread",
    lead: "Create a continuous cinematic thread across remote terrain and multiple days without relying on full broadcast-truck coverage.",
    layout: "Relay + AI Content Guard",
    layoutDetail: "GPS-activated geographic checkpoints and rugged-terrain verification",
    workflowTitle: "Remote checkpoint capture",
    workflow: [
      "Activate geographic checkpoints as athletes ping course GPS waypoints.",
      "An accredited creator on an isolated ridge uploads a 10-second micro-clip as frontrunners pass.",
      "The master stream updates instantly for remote spectators.",
      "Three days after the finish, the athlete can inject a personal debrief into the final timeline slot.",
    ],
    outcome1Label: "Organizer impact",
    outcome1: "Reduces dependence on costly satellite production trucks by leveraging distributed verified videographers across remote checkpoints.",
    outcome2Label: "Weaver monetization",
    outcome2: "Trailside Weavers can receive flat bounties such as €50 per verified, AI-approved milestone capture in the supplied concept.",
    image: sportUltra,
  },
  {
    id: "officiating-review",
    number: "07",
    category: "Pro leagues & federations",
    title: "The Officiating Review & Retroactive Diagnostic",
    lead: "Turn a controversial incident into a persistent evidence object that gains verified analytical layers as they become available.",
    layout: "Versus + AI Content Guard",
    layoutDetail: "Millisecond angle comparison with compliance validation",
    workflowTitle: "Successive review phases",
    workflow: [
      "Phase 1 live: the raw broadcast wide-angle feed.",
      "Phase 2 D+1: synchronized 50/50 comparison with an isolated production camera.",
      "Phase 3 D+2: add the referee’s authenticated field-mic audio synchronized to physical contact.",
    ],
    outcome1Label: "Federation & broadcaster impact",
    outcome1: "Creates a transparent public-interest asset that can also sit behind premium sports-media syndication tiers.",
    outcome2Label: "Weaver monetization",
    outcome2: "Retired elite referees and accredited analysts can earn automated consulting fees as structured educational annotations are reused by media or clubs.",
    image: sportReview,
  },
  {
    id: "collaborative-drop",
    number: "08",
    category: "Surfing, skateboarding & freestyle",
    title: "The Collaborative Action Sports “Drop”",
    lead: "Let a raw trick or line become an open living canvas enriched by specialized creative contributors without re-rendering or duplicating the root asset.",
    layout: "Seed + Symphony",
    layoutDetail: "Decentralized creative layers with audio-visual synchronization",
    workflowTitle: "Layered collaborative drop",
    workflow: [
      "Layer 1: raw mobile or FPV chase-drone footage of the trick.",
      "Layer 2: a verified producer adds an original soundtrack locked to the landing transient.",
      "Layer 3: a motion designer adds dynamic telemetry for velocity, airtime and rotation.",
      "The file mutates at its source URL without fracturing reach or engagement metrics.",
    ],
    outcome1Label: "Sponsor impact",
    outcome1: "Sponsors and hardware brands can deploy shoppable living-media campaigns linked directly to checkout.",
    outcome2Label: "Weaver monetization",
    outcome2: "The supplied example splits generated revenue 50% athlete, 25% camera operator, 15% music producer and 10% motion designer.",
    image: sportDrop,
  },
];

export default function SportPage() {
  return (
    <UseCaseTemplate
      pageTitle={"Sport"}
      currentPath={"/use-cases/sport"}
      eyebrow={"WEAVEVO USE CASE · SPORT"}
      heroTitle={"Turn every sporting moment into a living media layer."}
      heroText={"Connect organizers, clubs, athletes, fans, camera operators and analysts through persistent sports media that evolves across the route, the match and the days after the final whistle."}
      heroAlt={"Football supporter using Weavevo during a live match"}
      finalEyebrow={"BUILD THE NEXT SPORT WEAVE"}
      finalTitle={"The final whistle does not have to end the media value."}
      finalText={"Build persistent match, race and action-sports stories that can evolve, reward verified contributors and create new digital products around the same root link."}
      heroImage={sportHero}
      experiences={experiences}
    />
  );
}
